import React from 'react';
import PropTypes from 'prop-types';

import Tooltip from "../common/Tooltip";

const propTypes = {
	term: PropTypes.string.isRequired,
	children: PropTypes.node,
	className: PropTypes.string,
    termTooltip: PropTypes.string,
};

const defaultProps = {
	children: null,
	className: '',
    termTooltip: '',
};

function StatTile({ term, children, className, termTooltip }) {
    return (
        <div className={`stat-tile ${className}`}>
            <label
                className="stat-term"
                htmlFor={`stat-tile-${term}`}
            >
                { term } {(!!termTooltip) &&
                    <Tooltip
                        id={`stat-tile-${term}-tt`}
                        className="margin-left-sm"
                    >
                        {termTooltip}
                    </Tooltip>
                }
            </label>
            <div
                id={`stat-tile-${term}`}
                className="stat-def"
            >
                { children }
            </div>
        </div>
    );
}

StatTile.propTypes = propTypes;
StatTile.defaultProps = defaultProps;

export default StatTile;
